import { css } from '@emotion/react';

import { colors } from '../../configs';

export const bodyStyles = (isHeaderShown, isPaddingActive, backgroundColor) => css`
  min-height: calc(100vh - ${isHeaderShown ? '140px' : '60px'});
  padding: ${isPaddingActive ? '40px 0 90px 0' : '0'};
  background-color: ${colors[backgroundColor]};
`;
